/* eslint-disable jsx-a11y/no-access-key */
import Avatar from "@material-ui/core/Avatar"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import Link from "@material-ui/core/Link"
import Paper from "@material-ui/core/Paper"
import { makeStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Tooltip from "@material-ui/core/Tooltip"
import Typography from "@material-ui/core/Typography"
import LockOutlined from "@material-ui/icons/LockOutlined"
import { useState } from "react"
import { connect } from "react-redux"
import { setData as setDataFn } from "../actions/dataActions"
import { loginUser } from "../actions/userActions"
import arFlag from "../assets/images/iq.png"
import kuFlag from "../assets/images/ku.png"
import HeavyBoxSVG from "../assets/svg/heavy_box.svg"
import axios from "../axiosConfig"
import { translate } from "../lang"
import { errorGenerator } from "../utils"
import { toastError, toastSuccess } from "./App"

function Copyright() {
  return (
    <div style={{ marginTop: "50px" }}>
      {" "}
      <Typography variant="h5" color="primary" align="center">
        {/* {"ئەم بەرهەمە گەشەپێدراوە لەلایەن تیمی   "} */}
        <Link
          color="inherit"
          href="https://www.instagram.com/hiload_system/"
          style={{ textDecoration: "none", color: "rgb(61,63,84)" }}
        >
          Developed by Hiload System
        </Link>
        {/* {"وە"} */}

        {/* <div>
    <a
      href="tel:+96407707911010"
      style={{ textDecoration: "none", color: "grey" }}
    >
      {"1010 791 0770"}
    </a>
  </div> */}
        {/* <div></div> */}

        {/* <div>
    {" "}
    {new Date().getFullYear()}
    {" © "}
  </div> */}
      </Typography>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "calc(100vh - 20px)",
  },
  image: {
    backgroundImage: `url(${HeavyBoxSVG})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "calc(100vh - 130px)",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const intialValues = {
  phone: "",
  password: "",
}

function Signin({ data2, login, setData, setLoading }) {
  const classes = useStyles()

  const [values, setValues] = useState(intialValues)

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    })
  }

  const SigninUser = (e) => {
    e.preventDefault()

    if (values.phone === "" || values.password === "") {
      toastError(
        `${translate("please_enter_username_and_password", data2.lang)}`
      )
      return
    }

    delete axios.defaults.headers.common["Authorization"]
    setLoading(true)
    axios
      .post(`login`, {
        phone: values.phone,
        password: values.password,
      })
      .then((res) => {
        setLoading(false)
        login(res.data)

        toastSuccess(`${translate("login_success_message", data2.lang)}`)
        setData({
          message: "",
        })
      })
      .catch((error) => {
        setLoading(false)

        errorGenerator(
          error,
          toastError,
          `${translate("login_error_message", data2.lang)}`
        )
      })
  }

  return (
    <Grid container component="main" className={classes.root}>
      <div style={{}}>
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            marginLeft: "0.3vw",
            marginRight: "0.3vw",
          }}
        >
          <Tooltip
            title={`${translate("language", data2.lang)} {Z}`}
            accessKey="Z"
          >
            <img
              src={data2.lang === "ku" ? arFlag : kuFlag}
              alt="ku/ar flag"
              width="24px"
              height="24px"
              className={classes.icon}
              onClick={() => {
                if (data2.lang === "ku") {
                  setData({
                    lang: "ar",
                  })
                } else {
                  setData({
                    lang: "ku",
                  })
                }
              }}
            />
          </Tooltip>
        </div>
      </div>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlined />
          </Avatar>
          <Typography component="h1" variant="h5">
            {`${translate("login", data2.lang)}`}
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              onChange={handleChange}
              value={values.phone}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="phone"
              label={`${translate("phone_numer", data2.lang)}`}
              name="phone"
              autoComplete="phone"
              autoFocus
            />
            <TextField
              onChange={handleChange}
              value={values.password}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label={`${translate("password", data2.lang)}`}
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={SigninUser}
            >
              {`${translate("login", data2.lang)}`}
            </Button>
            <br></br>
            <div
              style={{ textAlign: "center", color: "red", fontSize: "18px" }}
            >
              <span>{data2.message}</span>
            </div>
            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
    </Grid>
  )
}

const mapStateToProps = (state) => {
  return { data2: state.data }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (user) => {
      dispatch(loginUser(user))
    },
    setData: (data) => {
      dispatch(setDataFn(data))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Signin)
